import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { LANGUAGE_CONFIG, CURRENCY_CONFIG, getCurrencyForLanguage } from '@/configured/languages/config';

Vue.use(VueI18n);

// Build numberFormats dynamically from centralized language config
const numberFormats = {};
Object.keys(LANGUAGE_CONFIG).forEach(langCode => {
  numberFormats[langCode] = {
    currency: getCurrencyForLanguage(langCode),
  };
});

const i18n = new VueI18n({
  fallbackLocale: 'en',
  numberFormats,
});

export default i18n;
